import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormControl } from '@angular/forms';

@Component({
  selector: 'app-auth-password-field',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './auth-password-field.component.html',
  styleUrls: ['./auth-password-field.component.scss'],
})
export class AuthPasswordFieldComponent {
  @Input({ required: true }) control!: FormControl<string>;
  @Input() placeholder = 'Password';
  @Input() invalidHint = 'Invalid password';
  /** When false, only border/state is shown; parent supplies message (e.g. mismatch). */
  @Input() showInvalidHint = true;
  /** Treat `serverError` validator as error styling on the container. */
  @Input() treatServerErrorAsInvalid = true;
  /** Cross-field errors (e.g. password mismatch on parent FormGroup). */
  @Input() forceShowError = false;
  @Input() autocomplete: 'current-password' | 'new-password' = 'current-password';

  isPasswordVisible = false;

  get hasServerError(): boolean {
    return this.treatServerErrorAsInvalid && !!this.control.errors?.['serverError'];
  }

  get showContainerError(): boolean {
    return this.forceShowError || (this.control.invalid && this.control.touched) || this.hasServerError;
  }

  get showHint(): boolean {
    if (!this.showInvalidHint) return false;
    return this.control.invalid && this.control.touched && !this.control.errors?.['serverError'];
  }

  toggleVisibility(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }
}
